// @ts-nocheck

export class MaskEmail {
  // private regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

  private regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const newValue = (value || '').toString().replace(/[^\d\w_.@-]/g, '');
    return { newValue, newCursorPosition: cursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    const { newValue, newCursorPosition } = this.removeMask(value, cursorPosition);
    return { formatedValue: newValue, formatedCursorPosition: newCursorPosition };
  }

  private isValid(value: string): boolean {
    const stripped = this.removeMask(value, null).newValue;

    if (!stripped) return false;
    if (!this.regex.test(stripped)) return false;

    // validacao de dois sinais de @
    let totalAtSign = 0;
    for (let chars = 0; chars < stripped.length; chars++)
      if (stripped.charAt(chars) === '@') totalAtSign++;
    if (totalAtSign > 1) return false;

    return true;
  }

  public validation = (
    value,
    focusOut
  ): Array<{ status: 'ok' | 'warn' | 'err'; msgCode: string }> => {
    if (!value) return [];
    let status: 'ok' | 'warn' | 'err' = 'warn';
    let msgCode = 'email-incomplete';

    if (focusOut) {
      if (this.isValid(value)) {
        msgCode = 'email-valid';
        status = 'ok';
      } else {
        status = 'err';
        msgCode = 'email-invalid';
      }
    }

    return [{ status, msgCode }];
  };

  public validate(value) {
    return value.match(this.regex);
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['EMAIL']];
  }
}
